// EnhancedQuoteSection.jsx
import React from 'react';

import { useLanguage } from '../../helpers/language-context';

const QuoteSection = () => {
  const { translations } = useLanguage();

  return (
    <section className="relative min-h-[500px] lg:h-[65vh] w-full flex items-center py-16 lg:py-0 overflow-hidden">
      {/* Background Image */}
      <div
        className="absolute inset-0 w-full h-full bg-cover bg-center"
        style={{
          backgroundImage: "url('/assets/images/quote_ceo.jpg')"
        }}
      />

      {/* Gradient Overlay - Blue to Transparent */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#28357BF2] via-[#28357B99] to-transparent" />

      {/* Content */}
      <div className="container mx-auto px-6 lg:px-12 relative z-10">
        <div className="max-w-full md:max-w-[70%] lg:max-w-[60%]">
          {/* Orange Icon/Logo */}
          <div className="mb-8">
            <div className="text-orange-500 flex items-center justify-start">
              <svg
                height="27px"
                width="27px"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
                fill="currentColor"
                style={{ transform: 'rotate(180deg)' }}
              >
                <g>
                  <path
                    d="M119.472,66.59C53.489,66.59,0,120.094,0,186.1c0,65.983,53.489,119.487,119.472,119.487 c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.135,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.829-6.389 c82.925-90.7,115.385-197.448,115.385-251.8C238.989,120.094,185.501,66.59,119.472,66.59z"
                    fill="currentColor"
                  />
                  <path
                    d="M392.482,66.59c-65.983,0-119.472,53.505-119.472,119.51c0,65.983,53.489,119.487,119.472,119.487 c0,0-0.578,44.392-36.642,108.284c-4.006,12.802,3.136,26.435,15.945,30.418c9.089,2.859,18.653,0.08,24.828-6.389 C479.539,347.2,512,240.452,512,186.1C512,120.094,458.511,66.59,392.482,66.59z"
                    fill="currentColor"
                  />
                </g>
              </svg>
            </div>
          </div>

          {/* Main Text */}
          <h1 className="text-xl md:text-2xl lg:text-3xl text-white mb-8 leading-tight font-medium">
            {translations.home.quote}
          </h1>

          {/* Author Info */}
          <div className="border-l-4 border-orange-500 pl-4">
            <p className="text-white font-semibold text-lg">Nizran Noordin</p>
            <p className="text-gray-300 text-sm italic">Chief Executive Officer</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default QuoteSection;
